import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../";
import { Resource } from "../../../types/acl";

type Props = {
    children: JSX.Element;
    permission: Resource | Resource[];
};

const AdminRoute = ({ children, permission }: Props) => {
    const { loading, hasPermission } = useContext(AuthContext)!;

    if (loading) {
        return <></>;
    }

    const permissions = Array.isArray(permission) ? permission : [permission];
    const canAccess = permissions.some((value) => hasPermission(value, "read"));

    return canAccess ? (
        children
    ) : (
        <Navigate to="/login" />
    );
};

export default AdminRoute;
